<template>
  <div class="mapDialog" ref="mapDialog">
    <chart-dialog :detailInfo="detailInfo"></chart-dialog>
    <vj-map ref="map"></vj-map>

    <!-- <el-select class="project" v-model="projectId" placeholder="请选择项目名称">
      <el-option v-for="item in projectList" :key="item.projectId" :label="item.projectName"
        :value="item.projectId"></el-option>
    </el-select> -->

    <map-dialog ref="popup" :detailInfo="detailInfo" @fresh="fresh"></map-dialog>
    <div class="popup" ref="bindDevice" v-show="showBindDevice">
      <div class="header">
        <p>绑定设备</p>
      </div>
      <div class="content global-map-dialog">
        <el-form :model="info" ref="form" :rules="rules">
          <el-form-item label="设备串号" prop="deviceNumber">
            <el-select v-model="info.deviceNumber" placeholder="选择绑定设备">
              <el-option v-for="(item, index) in deviceList"
                :label="(item.deviceName || '') + '(' + item.deviceNumber + ')'" :value="item.deviceNumber"
                :key="index">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div class="global-button-Section">
          <div class="button" @click="onSubmit">确定</div>
          <div class="button light" @click="onClose">取消</div>
        </div>
      </div>
    </div>

    <div class="map-style">
      <div class="item" :class="{ active: layers.cad }" @click="onMenuSelect('3-3')">
        <icon name="icon-CAD"></icon>
        <span>CAD</span>
      </div>
      <div class="item" :class="{ active: layers.road }" @click="onMenuSelect('3-2')">
        <icon name="icon-pingmian"></icon>
        <span>平面地图</span>
      </div>
      <div class="item" :class="{ active: layers.satellite }" @click="onMenuSelect('3-1')">
        <icon name="icon-weixing"></icon>
        <span>卫星地图</span>
      </div>
    </div>
  </div>
</template>

<script>
import ChartDialog from './ChartDialog.vue'
import { deviceAjax, getMapIcon, deviceTypeParamList, updateAjax } from './mapIcon'
import MapDialog from './MapDialog'
import { px2vw } from '@/utils/util'
import VjMap from '@/views/layout/map/VjMap'
// import vjmap from 'vjmap'
export default {
  name: 'DeviceMap',
  components: {
    VjMap,
    ChartDialog,
    MapDialog
  },
  data() {
    return {
      marker: [],
      detailInfo: {},
      deviceList: [],
      showBindDevice: false,
      info: {
        objectId: '',
        deviceNumber: '',
        objectType: '',
        projectId: ''
      },
      rules: {
        deviceNumber: [{ required: true, message: '请绑定设备', trigger: ['blur', 'change'] }]
      },
      cadDisabled: false,
      layers: {
        road: true,
        satellite: false,
        cad: true
      },
      mapInit: false
    }
  },
  computed: {
    projectId() {
      return this.$route.query.projectId
    },
    projectList() {
      return this.$store.state.projectList
    },
    project() {
      return this.projectList.find(item => item.projectId === this.projectId)
    },
    isCad() {
      return !!this.project.cadId
    },
    deviceType() {
      return this.$route.query.deviceType
    }
  },
  watch: {
    isCad: {
      immediate: true,
      handler(val) {
        this.cadDisabled = !val
        this.layers.cad = val
      }
    }
  },
  created() {
    this.$event.$on('mapOnload', () => {
      this.loadData(this.deviceType)
    })
  },
  destroyed() {
    this.$event.$off('mapOnload')
    this.clearOverlayer()
  },
  methods: {
    onMenuSelect(index) {
      switch (index) {
        case '1-1': // 新建
          // this.$event.$emit('newProject')
          this.$router.push('/new')
          break
        case '1-2': // 编辑
          this.$router.push('/edit')
          break
        case '1-3': // 导入
          this.$event.$emit('importCad')
          break
        case '1-4': // 导出
          break
        case '2': // 制图
          this.$router.push('/measure')
          break
        case '3-1': // 卫星云图
          this.layers.satellite = !this.layers.satellite
          this.$event.$emit('toggleLayer', {
            type: 'gaodeImgSource',
            visible: this.layers.satellite
          })
          this.layers.road = false
          this.$event.$emit('toggleLayer', {
            type: 'gaodeRoadSource',
            visible: this.layers.road
          })
          break
        case '3-2': // 平面地图
          this.layers.satellite = false
          this.$event.$emit('toggleLayer', {
            type: 'gaodeImgSource',
            visible: this.layers.satellite
          })
          this.layers.road = !this.layers.road
          this.$event.$emit('toggleLayer', {
            type: 'gaodeRoadSource',
            visible: this.layers.road
          })
          break
        case '3-3': // CAD图
          this.layers.cad = !this.layers.cad
          this.$event.$emit('toggleLayer', {
            type: 'cadSource',
            visible: this.layers.cad
          })
          break
        case '4-1': // AutoCAD
          // shell.openExternal('https://www.baidu.com')
          window.electronAPI.openSoftware('acad')
          break
        case '4-2': // Sketchup
          window.electronAPI.openSoftware('Sketchup')
          break
        case '4-3': // Photoshop
          window.electronAPI.openSoftware('Photoshop')
          break
        case '5-1': // 暗黑
          this.setTheme('black')
          break
        case '5-2': // 高级灰
          this.setTheme('grey')
          break
        case '5-3': // 科技蓝
          this.setTheme('blue')
          break
        case '6-1': // 智库问答
          this.showDialog = true
          this.title = '智库问答'
          break
        case '6-2': // 操作手册
          this.showDialog = true
          this.title = '操作手册'
          break
        case '6-3': // 常见问题
          this.showDialog = true
          this.title = '常见问题'
          break
        default:
      }
    },
    removeMarker() {
      if (this.marker.length > 0) {
        this.marker.forEach(item => item.remove())
      }
      this.marker = []
    },
    clearOverlayer() {
      this.removeMarker()
      this.showBindDevice = false
      this._popup && this._popup.remove()
    },
    async loadData(deviceType) {
      // this._map = this.$parent.$children[0]._map
      this._map = this.$refs.map._map
      const data = await this.$axios.get(deviceAjax.get(deviceType), { projectId: this.projectId })
      const markList = (deviceTypeParamList.get(deviceType) ? data[deviceTypeParamList.get(deviceType)].list : data.list).map(item => {
        return { ...item, deviceType: deviceType }
      })
      let elecList = []
      let lyList = []
      // 水电
      if (deviceType === '1004') {
        const data = await this.$axios.get(deviceAjax.get('1014'), { projectId: this.projectId })
        elecList = (deviceTypeParamList.get('1014') ? data[deviceTypeParamList.get('1014')].list : data.list).map(item => {
          return { ...item, deviceType: '1014' }
        })
        const data1 = await this.$axios.get(deviceAjax.get('liuya'), { projectId: this.projectId })
        lyList = (deviceTypeParamList.get('liuya') ? data1[deviceTypeParamList.get('liuya')].list : data1.list).map(item => {
          return { ...item, deviceType: 'liuya' }
        })
      }
      const list = [...markList, ...elecList, ...lyList]
      if (list.length > 0) {
        this.addCadMarker(this._map, list)
      } else {
        this._map.setCenter(parent.mapCenter)
        // this._map.setZoom(15)
      }
    },
    // addCadMarkers (device, deviceType) {
    //   if (device.length > 0) {
    //     this.addCadMarker(this._map, device.map(item => {
    //       return { ...item, deviceType: deviceType }
    //     }), deviceType)
    //   } else {
    //     this._map.setCenter(parent.mapCenter)
    //     this._map.setZoom(15)
    //   }
    // },
    // 查询未绑定的设备
    getNoBindDevice(deviceType) {
      this.$axios.get(deviceAjax.get(deviceType), {
        isCad: '0',
        isDeviceCad: '0',
        projectId: this.projectId
      }).then(res => {
        this.deviceList = deviceTypeParamList.get(deviceType) ? res[deviceTypeParamList.get(deviceType)].list : res.list || []
      })
    },
    addCadMarker(map, list) {
      list.forEach(item => {
        const el = document.createElement('div')
        el.className = 'marker'
        el.style.backgroundImage = `url('${getMapIcon(item.deviceType, item)}')`
        el.style.width = !item.deviceNumber ? '48px' : '36px'
        el.style.height = '48px'
        el.style.backgroundSize = '100%'
        // 有cad图层未绑定设备cad转经纬度
        // if (!item.deviceNumber) {
        // }
        if (this.isCad) {
          const cadPoints = vjmap.geoPoint([item.objectX, item.objectY])
          const lngLat = this._map.cadToWebCoordinate(cadPoints)
          item.longitude = lngLat[0]
          item.latitude = lngLat[1]
        }
        const co = [item.longitude, item.latitude]
        const marker = new vjmap.Marker({
          element: el,
          anchor: 'bottom'
        })
        marker.setLngLat(co).addTo(map)
        el.addEventListener('click', (e) => {
          this.info.deviceNumber = ''
          // 有cad图层未绑定设备
          if (!item.deviceNumber) {
            this.showBindDevice = true
            this.info.objectId = item.objectId
            this.info.projectId = this.projectId
            this.getNoBindDevice(item.deviceType)
            this.addBindDevicePopup(map, co)
            this._bindDeviceInfo = item
          } else {
            this.detailInfo = item
            this.$nextTick(() => {
              const el = this.$refs.popup.$el
              marker.setPopup(new vjmap.Popup({ closeOnClick: true, closeButton: false, anchor: 'bottom', offset: [0, -px2vw(50)] }).setDOMContent(el))
            })
          }
        })
        this.marker.push(marker)
      })

      // 获取cad坐标
      // const pts = this.marker.map(c => map.fromLngLat(c.getLngLat()))
      // const showBounds = vjmap.geoBounds()
      // showBounds.update(pts) // 得到所有点坐标的范围
      // const lngLatBounds = map.toLngLat(showBounds)
      // map.fitBounds(lngLatBounds, {
      //   padding: px2vw(120) // 旁边留几十个像素，方便全部看到
      // })
      this.$refs.map.setFitMarkers()
    },
    // 绑定设备弹框
    addBindDevicePopup(map, lngLat) {
      const el = this.$refs.bindDevice
      setTimeout(() => {
        const popup = new vjmap.Popup({ closeOnClick: true, closeButton: false, offset: [0, -px2vw(50)] })
        popup.setDOMContent(el).setLngLat(lngLat).addTo(map)
        this._popup = popup
      }, 10)
    },
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$axios.post(this.$apis.device.updateJgCad, this.info).then(res => {
            this.$message.success('绑定成功')
            this.updateLocation()
            this.clearOverlayer()
            this.loadData(this.deviceType)
          })
        }
      })
    },
    updateLocation() {
      const index = this.deviceList.findIndex(item => item.deviceNumber === this.info.deviceNumber)
      this.$axios.post(updateAjax.get(this.deviceType), {
        deviceNumber: this.info.deviceNumber,
        longitude: this._bindDeviceInfo.longitude,
        deviceName: this.deviceList[index].deviceName,
        latitude: this._bindDeviceInfo.latitude
      }).then(() => {
        this.$message.success('保存成功')
        this.isEdit = false
      })
    },
    onClose() {
      this.showBindDevice = false
      this._popup && this._popup.remove()
    },
    fresh() {
      this.clearOverlayer()
      this.loadData(this.deviceType)
    }
  }
}
</script>

<style scoped lang='scss'>
.mapDialog {
  height: 100%;
}

.map-style {
  position: absolute;
  bottom: 40px;
  right: 40px;
  width: 240px;
  height: 80px;
  background: #FFFFFF;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.17);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;

  .item {
    position: relative;
    height: 80px;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    &.active {
      .icon-wrap {
        color: #0076FF;
      }

      span {
        color: #0076FF;
      }
    }

    .icon-wrap {
      font-size: 30px;
      color: #809FB8;
    }

    span {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: #809FB8;
      line-height: 20px;
      text-align: right;
      font-style: normal;
      text-transform: none;
      margin-top: 8px;
    }

    &:nth-child(n + 2) {
      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 1px;
        height: 50px;
        background: #F3F3F3;
      }
    }
  }
}

.popup {
  width: 400px;
  min-height: 150px;
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 14px;
  background: var(--map-popup-bg);
  border-radius: 10px;

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 34px;
    background: #2E3C55;
    padding: 10px 19px;
    color: #FFFFFF;
    border-radius: 10px 10px 0 0;
  }

  .content {
    color: var(--header-bar-title-color);
    padding: 16px 0 0 19px;
  }
}

.project {
  position: absolute;
  left: 40px;
  bottom: 55px;
  width: 150px;
  height: 50px;
  background: #FFFFFF;
  box-shadow: 0px 5px 10px 0px rgba(186, 186, 186, 0.6);
  border-radius: 4px;
  z-index: 999;

  ::v-deep {

    .el-input,
    input {
      height: 100% !important;
    }
  }
}
</style>
